<div class="container">
  <div class="digital-signature" [reactComponent]="DigitalSignature" [props]="props"></div>
</div>
